<div class="card tile-shadow h-100">
  <div class="card-header bg-white header">
    <div class="row">
      <div class="col-10">
        <h3 class="fw-bold card-title">To Do List</h3>
      </div>
      <div class="col-2 text-end">
        <img src="assets/icons/clipboard-checks.png" />
      </div>
    </div>
  </div>
  <div class="d-flex flex-column justify-content-between h-75 list-group list-group-flush">
    <a
      class="list-group-item list-group-item-action link-border"
      routerLink="{{ baseUrl }}/{{ clientCode }}/people"
      *ngIf="canAccessPeople">
      <div class="d-flex flex-row justify-content-between">
        <div>
          <span class="fw-bold">Add / Edit People</span> <br />
          <span>Hired new employees / contractors?</span>
        </div>
        <div class="text-end">
          <img class="mt-2" src="assets/icons/chevron-right.svg" />
        </div>
      </div>
    </a>
    <a
      *ngIf="payrollRoute != null && payrollRoute != '' && canAccessPayroll"
      [routerLink]="payrollRoute"
      class="list-group-item list-group-item-action link-border">
      <div class="d-flex flex-row justify-content-between">
        <div class="mt-auto mb-auto">
          <span class="fw-bold mt-auto mb-auto">
            {{ payrollButtonText }}
          </span>
          <br />
          <span class="mt-auto mb-auto">{{ payrollTileText }}</span>
        </div>
        <div class="text-end mt-auto mb-auto">
          <img class="mt-2" src="assets/icons/chevron-right.svg" />
        </div>
      </div>
    </a>
    <a
      class="list-group-item list-group-item-action link-border"
      *ngIf="canManageUsers"
      [routerLink]="'./settings'"
      [queryParams]="{ active: 3 }">
      <div class="d-flex flex-row justify-content-between">
        <div>
          <span class="fw-bold mt-auto mb-auto">Manage Users</span> <br />
          <span class="mt-auto mb-auto">Add/Edit/Remove an account user</span>
        </div>
        <div class="text-end">
          <img class="mt-2" src="assets/icons/chevron-right.svg" />
        </div>
      </div>
    </a>
  </div>
</div>
